// Maps a video language name to one or more ISO 3166-1 alpha-2 country codes.
// Rendered as crisp flag images via flagcdn. Unknown languages return [] (globe fallback).
const LANG_FLAGS = {
  "english": ["gb", "us"],
  "spanish": ["es"],
  "french": ["fr"],
  "german": ["de"],
  "portuguese": ["pt"],
  "brazilian portuguese": ["br"],
  "portuguese (brazilian)": ["br"],
  "portuguese (brazil)": ["br"],
  "hindi": ["in"],
  "japanese": ["jp"],
  "korean": ["kr"],
  "italian": ["it"],
  "chinese": ["cn"],
  "mandarin": ["cn"],
  "cantonese": ["hk"],
  "arabic": ["sa"],
  "russian": ["ru"],
  "dutch": ["nl"],
  "polish": ["pl"],
  "turkish": ["tr"],
  "swedish": ["se"],
  "norwegian": ["no"],
  "danish": ["dk"],
  "finnish": ["fi"],
  "greek": ["gr"],
  "hebrew": ["il"],
  "thai": ["th"],
  "vietnamese": ["vn"],
  "indonesian": ["id"],
  "malay": ["my"],
  "filipino": ["ph"],
  "tagalog": ["ph"],
  "ukrainian": ["ua"],
  "czech": ["cz"],
  "romanian": ["ro"],
  "hungarian": ["hu"],
  "persian": ["ir"],
  "farsi": ["ir"],
  "urdu": ["pk"],
  "bengali": ["bd"],
  "tamil": ["in"],
  "telugu": ["in"],
  "punjabi": ["in"],
  "swahili": ["ke"],
};

export function flagCodes(language) {
  if (!language) return [];
  return LANG_FLAGS[language.trim().toLowerCase()] || [];
}

export const flagUrl = (code) => `https://flagcdn.com/w40/${code}.png`;
export const flagUrl2x = (code) => `https://flagcdn.com/w80/${code}.png`;
